<template>
  <div id="disclaimer" v-if="hasCookie !== true">
    <div class="disclaimer-container">
      <span>This site uses cookies and external scripts to improve your experience.</span>
      <button class="button" @click="accept">ACCEPT</button>
    </div>
  </div>
</template>

<script>
const name = 'disclaimer'

const methods = {
  accept () {
    const wrap = document.querySelector('#app')
    wrap.style['padding-bottom'] = '0px'
    this.hasCookie = true
    document.cookie = 'op_forecasting_cookie_disclaimer=accept; expires=Fri, 31 Dec 9999 23:59:59 GMT'
  }
}

export default {
  name,
  methods,
  data () {
    /* eslint-disable-next-line */
    const cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)op_forecasting_cookie_disclaimer\s*\=\s*([^;]*).*$)|^.*$/, '$1')
    return {
      hasCookie: cookieValue === 'accept'
    }
  },
  mounted () {
    if (this.hasCookie === false) {
      const wrap = document.querySelector('#app')
      const disc = document.querySelector('#disclaimer')
      wrap.style['padding-bottom'] = `${disc.offsetHeight}px`
    }
  }
}
</script>

<style>
#disclaimer {
  background-color: #353535;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99999;
  color: #fff;
  font-size: 16px;
}

.disclaimer-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

#disclaimer .button {
  margin-left: 40px;
  padding: 0 20px;
  text-transform: uppercase;
  line-height: 20px;
  height: 40px;
  font-weight: 500;
  letter-spacing: 1px;
  background-color: #fff;
  color: #000;
}
</style>
